// ============================================
// File: components/pages/Support.jsx
// Support page displayed when runtime errors occur
// ============================================

import React from 'react';
import { CircleCheck, Mail, ArrowLeft, RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import '../../styles/support.css';
import logo from '../../assets/logo3.png';

const Support = ({ 
  error = null, 
  errorInfo = null,
  resetError = null,
  showBackButton = true 
}) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (resetError) {
      resetError();
    }
    navigate(-1);
  };

  const handleGoHome = () => {
    if (resetError) {
      resetError();
    }
    navigate('/');
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  // Extract error message if available
  const errorMessage = error?.message || error?.error || 'An unexpected error occurred';
  const isSignupError = errorMessage.toLowerCase().includes('signup') || 
                        errorMessage.toLowerCase().includes('auth0') ||
                        errorMessage.toLowerCase().includes('registration');

  return (
    <div className="support-page">
      <div className="support-container">
        {/* Error Icon */}

        <div className="logo-wrapper">
                  <img src={logo} alt="Booking System" className="logo-img" />
                </div>
    
        {/* Description */}
        <div className="explore-description">
          <p>
            We are excited to welcome you on our journey!
          </p>
          <p>
            Please stay with us a little longer—powerful and innovative features are coming soon, designed to save your valuable time and elevate your experience.
          </p>
        </div>
        {/* Contact Information */}
        <div className="support-contact">
          <div className="support-contact-header">
            <Mail size={20} />
            <h3>Need Immediate Help?</h3>
          </div>
          <p>Please contact our support team for assistance:</p>
          <a 
            href="mailto:nbipinraj@bipzapp.com?subject=Signup Error - Support Request"
            className="support-email"
          >
            nbipinraj@bipzapp.com
          </a>
          <p className="support-contact-note">
            Please share your contact details along with a brief description of your driving instructor needs.
          </p>
        </div>
          <button 
            onClick={handleGoHome} 
            className="btn-support btn-outline"
          >
            Go to Home
          </button>
        </div>
       
      </div>
  );
};

export default Support;